import {
  BaseFormComponent,
  BaseFormHeaderInfo
} from '../../tasks/baseFormComponent/baseForm.component';
import { Component, OnInit, Optional, ElementRef, AfterContentInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { EnvelopeDTO } from '../../api/plyca-dtos-v2';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, throwError } from 'rxjs';
import { generateRandomIdentifier } from '../../ui.service';
import { TenderV2DTO, TenderEnvelopeDocumentDTO } from '../../api/plyca-dtos';
import { FormConfig } from '../../components/forms/form.objects';
import { HelpService } from '../../components/common/help/help.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { catchError, finalize, switchMap, tap } from 'rxjs/operators';
import * as lodash from 'lodash';

@Component({
  selector: 'tenderEnvelopedDocument-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html'
})
export class TenderEnvelopedDocumentEditorComponent
  extends BaseFormComponent<TenderEnvelopeDocumentDTO, TenderEnvelopeDocumentDTO>
  implements OnInit, AfterContentInit, OnDestroy {

  private identifier: string;
  tenderDoc: TenderEnvelopeDocumentDTO;
  tender: TenderV2DTO;
  tenderEnvelope: EnvelopeDTO;
  tagsParent: string[];

  constructor(
    elem: ElementRef,
    public translationService: TranslateService,
    public dialogConfig: DynamicDialogConfig,
    public helpService: HelpService,
    public ref: DynamicDialogRef,
    private plycaErrorHandler: PlycaErrorHandler,
    @Optional() protected activatedRoute: ActivatedRoute

  ) {

    super(elem);
    this.subscribe(
      this.helpService.getStoreTagsObservable().pipe(
        switchMap((helpTags) => this.tagsParent = helpTags)));
    this.identifier = dialogConfig['identifier'];
    if (!this.identifier) {
      this.identifier = 'new';
    }
    this.tender = dialogConfig['tender'];
    this.tenderEnvelope = dialogConfig['tenderEnvelope'];

    this.windowHash = generateRandomIdentifier();
  }


  getObjectParams(): { [param: string]: string | string[]; } {
    return {
      identifier: this.identifier
    };
  }

  ngOnDestroy(): void {
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {
        this.headerActionsService.clearWindowActions(this.windowHash);
        this.ref = null;
        this.dialogConfig = null;
        super.ngOnDestroy();
      })));
  }

  ngAfterContentInit(): void {
  }

  getFormSettingURL(): string {
    return 'tenderEnvelopedDocumentInterfaceSettings.json';
  }

  getServiceURL(): string {
    return this.configuration.TENDERENVELOPEDOCUMENT_V1_SERVICE_URL;
  }

  getObjectIdentifier(): string {
    console.log('getObjectIdentifier:', this.identifier);
    return this.identifier;
  }


  dtoToModel(dto: TenderEnvelopeDocumentDTO): Observable<TenderEnvelopeDocumentDTO> {
    // if (!dto.documentFile) {

    // }
    if (this.tender) {
      dto['documentClass'] = this.tender.documentClass
    }
    dto['_files'] = [];
    if (dto.documentFile) {
      dto['_files'].push(dto.documentFile);
    }
    return of(dto);
  }

  modelToDTO(model: TenderEnvelopeDocumentDTO): TenderEnvelopeDocumentDTO {
    // Establecer la referencia a la oferta y al sobre
    model.tender = this.tender;
    model.envelope = this.tenderEnvelope;

    // Eliminar referencias a datos de apoyo a la edicion
    if (model['_files'] && model['_files'].length > 0) {
      model.documentFile = model['_files'][0];
    } else {
      model.documentFile = undefined;
    }
    delete model['_files'];
    delete model['documentClass'];
    model = JSON.parse(
      JSON.stringify(model, (k, v) => (k === '_parent' ? undefined : v))
    );

    model.relatedCompany = this.tender.tendererParty.company;
    model.envelope = this.tenderEnvelope;
    if (lodash.isEmpty(model.relatedEnvelopeDocumentDefinition)) {
      model.relatedEnvelopeDocumentDefinition = undefined;
    }
    return model;
  }

  // getTitle(): string {
  //   return '';
  // }

  getHeaderInfo(): BaseFormHeaderInfo {
    return new BaseFormHeaderInfo();
    // let headerInfo = new BaseFormHeaderInfo();
    // headerInfo.titleKey = this.getTitle();
    // headerInfo.titleIcon = 'fas fas fa-file-invoice-dollar';
    // return headerInfo;
  }

  initHeaderActions() {
    this.subscribe(this.headerActionsService.addWindowAction('General.save', 'fas fa-save', 'btn-primary', true, this.windowHash),
      () => {
        this.waitService.startWaiting();
        this.subscribe(this.saveDocument().pipe(
          tap(() => {
            this.ref.close();
          }),
          catchError((error: any) => {
            this.waitService.cancelWaiting();
            return throwError(error);
          })
        )
        );
      }
    );
  }

  private saveDocument(): Observable<any> {
    if (this.model
      && this.model.identifier
      && !this.model.relatedEnvelopeDocumentDefinition
      && (!this.model['_files'] || this.model['_files'].length === 0)) {
      // borrar registro que no tiene documento asociado en la definicion de sobres
      return super.delete(false);
    } else {
      return super.save(false);
    }
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = true;
    formConfig.searchTags = ['OFERTA_INFO'];
    formConfig.windowHash = this.windowHash;
    return of(formConfig);
  }

  modalError(error) {
    this.ref.close();
    this.plycaErrorHandler.showServerError(error);
    // this.uiService.showMessage(
    //   error.errors[0].message,
    //   this.translateService.instant('General.error'),
    //   'errorStyle'
    // );
  }
}
